import apiClient from "../utils/apiClient";
import useSWR from "swr";

export const getAmenitiesGrouped = async () => {
  try {
    const res = await apiClient.get("/amenities/grouped/");
    return res.data;
  } catch (err) {
    console.error("Error fetching grouped amenities:", err);
    throw err;
  }
};

export const useAmenitiesGrouped = () => {
  const { data, error, isLoading, mutate } = useSWR(
    "/amenities/grouped/",
    getAmenitiesGrouped,
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: false,
      dedupingInterval: 300000,
    }
  );

  return {
    amenitiesGrouped: data || {},
    isLoading,
    error,
    mutate,
  };
};

export const updatePropertyAmenities = async (propertyId, amenitiesData) => {
  try {
    const res = await apiClient.patch(
      `/properties/${propertyId}/amenities/`,
      amenitiesData
    );
    return res.data;
  } catch (err) {
    console.error("Error updating property amenities:", err);
    throw err;
  }
};
